export const IS_DEV = process.env.NODE_ENV !== "production";
export const DCSD_COOKIE = "dcsdToken";

export const EMPLOYEE_DASHBOARD = IS_DEV ? "https://dev-employee.dcsdk12.org" : "https://employee.dcsdk12.org";

export const EVALUATION_SITE = IS_DEV ? "https://dev-evaluation.dcsdk12.org" : "https://evaluation.dcsdk12.org";
// 5 minute buffer
export const EXPIRY_BUFFER_MILLI = 300000;
// dynamic service host
export const SERVICE_HOST = IS_DEV ? "https://preprod-service.dcsdk12.org" : "https://prod-service.dcsdk12.org";
export const SAML_LOGOUT_URL = `${SERVICE_HOST}/auth/saml/logout`;
export const SPRING_COOKIE = "JESSIONID";
export const START_SESSION_URL = `${SERVICE_HOST}/auth/v1/auth/session`;
// check every minute if token is expired
export const TOKEN_EXPIRY_CHECK_MILLI = 60000;
// Countdown before automatic logout when prompt is ignored (4 minutes)
export const EXPIRY_PROMPT_COUNTDOWN_MILLI = 240000;
export const TOKEN_URL = `${SERVICE_HOST}/auth/v1/auth/token`;
export const TOKEN_URL_DEV = `${SERVICE_HOST}/auth-token/v1/auth`;

// Google Analytics tracking ID
export const TRACKING_ID = "UA-168847218-1";

export const SYNC_COOKIE_NAME = "dcsd_auth_sync_action";
